import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { loadChurnRiskCountAsync, selectChurnRiskCount } from '../dashboardSlice';
import { StatCard } from './StatCard';

// Estoque de alunos em risco: 7+ dias sem sessão ou nenhuma sessão nos
// últimos 30 dias, com assinatura válida (sem admins nem ocultos). NÃO é a
// mesma lista do ChurnRiskObserver: o worker notifica só quem cruza um
// limiar no dia (janelas configuráveis no AppConfig, ver
// CHURN_RISK_WORKER.md) e calcula o último acesso também por login e início
// da assinatura.
const INACTIVE_DAYS = 7;

export const ChurnRiskCard = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { count, status } = useSelector(selectChurnRiskCount);

    useEffect(() => {
        dispatch(loadChurnRiskCountAsync(INACTIVE_DAYS));
    }, [dispatch]);

    return (
        <StatCard
            label="Risco de churn"
            secondary={`${INACTIVE_DAYS}+ dias inativo`}
            icon="pi-exclamation-triangle"
            color="var(--orange-500)"
            value={count}
            loading={status === 'idle'}
            onClick={() => history.push('/users', { preset: 'churnRisk', presetLabel: `Risco de churn (${INACTIVE_DAYS}+ dias inativo)` })}
        />
    );
};
